import { render, staticRenderFns } from "./product-brand-edit-modal.vue?vue&type=template&id=6bed34f4&scoped=true&"
import script from "./product-brand-edit-modal.vue?vue&type=script&lang=js&"
export * from "./product-brand-edit-modal.vue?vue&type=script&lang=js&"
import style0 from "./product-brand-edit-modal.vue?vue&type=style&index=0&id=6bed34f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bed34f4",
  null
  
)

export default component.exports